/**
 * Returns the number of milliseconds until the next target second (0–59).
 * For example, if now is hh:mm:03.250 and targetSecond is 5,
 * this returns 1750ms.
 */
export const getMsUntilNextSecond = (targetSecond: number): number => {
  const now = new Date();
  const currentSec = now.getSeconds();
  const currentMs = now.getMilliseconds();

  const deltaSeconds = (targetSecond - currentSec + 60) % 60;
  const msUntilTarget = deltaSeconds * 1000 - currentMs;

  return msUntilTarget < 0 ? 0 : msUntilTarget;
};
